import { render, staticRenderFns } from "./BottomSheetLayout.vue?vue&type=template&id=59dc12a1&scoped=true&"
var script = {}
import style0 from "./BottomSheetLayout.vue?vue&type=style&index=0&id=59dc12a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc12a1",
  null
  
)

export default component.exports